export default {
  AD_CLICK: 'ad-click',
  AD_CARD_MONTHLY_RATE_CLICK: 'ad-card-monthly-rate-click',
  PHONE_CTA_CLICK: 'phone-cta-click',
  EMAIL_CTA_CLICK: 'email-cta-click',
  ENQUIRY_SUBMITTED: 'enquiry-submitted',
  SEARCH_WITH_FILTERS: 'search-with-filters',
  SEARCH_WITH_FILTERS_NO_RESULTS: 'search-with-filters-no-results',
  SEARCH_WITH_FORM: 'search-with-form',
  SHOW_FULLSCREEN_GALLERY: 'show-fullscreen-gallery',
  FINANCE_CALCULATOR_RANGE_CHANGE: 'finance-calculator-range-change',
  SCROLL_TO_SECTION_CLICK: 'scroll-to-section-click',
  CONTACT_FORM_CHANGE: 'contact-form-change',
  CAR_DETAILS_FAVORITE_CLICK: 'cf-cardetails-favorite-icon-click',
  AD_CARD_FAVORITE_CLICK: 'cf-ad-card-favorite-icon-click',
  AD_CARD_DISLIKE_CLICK: 'cf-ad-card-dislike-icon-click',
  FAVORITES_TOGGLE_LINK_CLICK: 'cf-favorites-toggle-link',
  FAVORITES_OVERVIEW_LINK_CLICK: 'cf-favorites-overview-link',
  DISLIKES_OVERVIEW_LINK_CLICK: 'cf-dislikes-overview-link',
  AD_CARD_PHONE_CTA_CLICK: 'cf-ad-card-phone-cta-click',
  AD_CARD_EMAIL_CTA_CLICK: 'cf-ad-card-email-cta-click',
  FAVORITE_NOTIFICATION_OVERVIEW_LINK_CLICK:
    'cf-favorite-notification-overview-link-click',
  DISLIKE_NOTIFICATION_OVERVIEW_LINK_CLICK:
    'cf-dislike-notification-overview-link-click',
  FAVORITES_OVERVIEW_LIKE_TAB_CLICK: 'cf-favorites-overview-like-tab-click',
  FAVORITES_OVERVIEW_DISLIKE_TAB_CLICK:
    'cf-favorites-overview-dislike-tab-click',
  AD_PROMO_BANNER_CLICK: 'cf-adlist-promo-banner-click',
  ENTRY_WD_TAB_CLICK: 'entry-wd-tab-click',
  ENTRY_WD_BRAND_TAB: 'entry-wd-brand-tab',
  ENTRY_WD_PRICE_TAB: 'entry-wd-price-tab',
  ENTRY_WD_BODY_TYPE_TAB: 'entry-wd-body-type-tab',
  PRICE_RANGE_SLIDER_CHANGE: 'cf-price-range-slider-change',
  PRICE_INPUT_RANGE_CHANGE: 'cf-price-input-range-box-change',
  AD_SHARE_BUTTON_CLICK: 'cf-ad-share-button-click',
  AD_SHARE_PROVIDER_CLICK: 'cf-ad-share-provider-click',
  WKDA_FM_LEGACY: 'wkda-fm',
  WKDA_FM: 'wkda-fm-v1',
  WKDA_FM_BASIC_DATA: 'wkda-fm-basic-data-v1',
  WKDA_FM_VEHICLE_DETAILS: 'wkda-fm-vehicle-details-v1',
  WKDA_FM_PERSONAL_DETAILS: 'wkda-fm-personal-details-v1',
  WKDA_FM_PREVIEW_MODE: 'wkda-fm-preview-mode-v1',
};
